import { ArrowRight, ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden pt-28 md:pt-32"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_website-builder-1896/artifacts/tgy5jjxc_Screenshot%202026-06-08%20135229.png')",
          backgroundPosition: "center 25%"
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A100D] via-[#0A100D]/85 to-[#0A100D]/45" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-24 md:pb-32 w-full">
        <h1
          data-testid="hero-headline"
          className="font-serif-display text-5xl sm:text-6xl lg:text-8xl leading-[1.02] tracking-tight max-w-5xl text-[#EFE9D4]"
        >
          I retired my income in seven years. <br />
          <span className="italic text-[#36C281]">Let me show you how.</span>
        </h1>
        <p
          data-testid="hero-subtext"
          className="mt-8 text-lg sm:text-xl text-neutral-300 max-w-2xl leading-relaxed"
        >
          An independent buyer's agent securing investment property nationally for Australians
          building serious portfolios — and family homes locally for buyers across Cairns.
          Rigorous research, disciplined selection, downside-first thinking.
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-4" data-testid="hero-cta-group">
          <a href="#contact" data-testid="hero-primary-cta" className="btn-primary">
            Book a Discovery Call <ArrowRight size={16} />
          </a>
          <a href="#results" data-testid="hero-secondary-cta" className="btn-outline">
            See Client Results
          </a>
          <a href="#ebook" data-testid="hero-ebook-cta" className="btn-outline">
            Free eBook: Buy Like a Pro
          </a>
        </div>
      </div>

      <a
        href="#results"
        aria-label="Scroll to results"
        data-testid="hero-scroll-indicator"
        className="absolute bottom-8 right-6 md:right-12 z-10 text-neutral-400 hover:text-[#36C281] transition-colors flex flex-col items-center gap-2"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase rotate-90 origin-center mb-8">Scroll</span>
        <ArrowDown size={16} />
      </a>
    </section>
  );
}
